<p-wrapper id="sign-in" titleWrapper="Se connecter" [showFooter]="true">
  <!-- Body de la carte d'authentification -->
  <div body>
    <div class="row justify-content-center">
      <button id="btn-id-not" class="btn-id-not" (click)="idNotSignIn()">
        <img src="assets/images/final-logo.png" style="height: 50px" alt="" />
      </button>
    </div>

    <p-separator>OU</p-separator>

    <app-sign-in-errors
      [showErrorMsg]="showErrorMsg"
      [showResetPasswordSuccessMsg]="showResetPasswordSuccessMsg"
      [showValidateSuccessMsg]="showValidateSuccessMsg"
      [showSessionExpiredMsg]="showSessionExpiredMsg"
      [showDefaultErrorMsg]="showDefaultErrorMsg"
      [showUseIdnotErrorMsg]="showUseIdnotErrorMsg"
      [showOrganismExistErrorMsg]="showOrganismExistErrorMsg"
    ></app-sign-in-errors>

    <form
      id="user-login"
      accept-charset="UTF-8"
      [formGroup]="loginForm"
      class="px-5"
    >
      <p-input
        [formControl]="this.loginForm.controls.username"
        id="identifiant"
        name="identifiant"
        label="Identifiant"
        description="Saisissez votre identifiant ou votre email."
        errorMessage="Identifiant obligatoire"
      ></p-input>

      <p-input
        [formControl]="this.loginForm.controls.password"
        [type]="resetPasswordInputType"
        [withRightIcon]="true"
        id="password"
        name="password"
        label="Mot de passe"
        description="Saisissez le mot de passe correspondant à votre identifiant."
        errorMessage="Mot de passe obligatoire"
      >
        <span rightIcon (click)="showResetPassword()">
          <i-feather
            *ngIf="!isPasswordDisplayed"
            name="eye"
            title="Afficher le mot de passe"
          ></i-feather>
          <i-feather
            *ngIf="isPasswordDisplayed"
            name="eye-off"
            title="Masquer le mot de passe"
          ></i-feather>
        </span>
      </p-input>

      <div class="d-flex justify-content-between mt-4">
        <p-button
          id="btn-connexion"
          label="Connexion"
          level="primary"
          [loading]="loading"
          [disabled]="loading"
          [width]="100"
          (click)="signIn()"
          class="col-5"
        ></p-button>
        <p-button
          id="btn-quitter"
          label="Quitter"
          level="tertiary"
          type="button"
          [width]="100"
          [disabled]="loading"
          routerLink="/"
          class="col-5"
        ></p-button>
      </div>
      <div class="d-flex align-items-center gap-3 float-end">
        <a
          *appFeatureFlag="FeaturesEnum.INSCRIPTION_AUTONOME"
          id="link-inscription"
          routerLink="/inscription"
          routerLinkActive="active"
          class="mt-3"
        >
          Créer mon compte
        </a>
        <a
          id="link-mot-de-passe-oublie"
          routerLink="/mot-de-passe-oublie"
          routerLinkActive="active"
          class="mt-3"
        >
          Mot de passe oublié ?
        </a>
      </div>
    </form>
  </div>

  <div class="row sign-in-footer" footer>
    <div class="d-flex col-4 border-end align-items-center">
      <img src="assets/images/logo_adnov.png" class="img-adnov" alt="" />
    </div>

    <div class="col-8 col-md-border">
      <div class="row">
        <p>
          Pour toute question concernant la création ou le fonctionnement d'un
          compte :
        </p>
        <img
          src="assets/images/hotline_num.png"
          class="img-num-service-client mx-auto mb-3"
          alt=""
        />
        <p>
          Service client : de 9h à 18h, du lundi au vendredi<br />
          Service technique : de 8h30 à 21h, du lundi au vendredi et de 8h30 à
          12h le samedi<br />
          Par email :
          <a href="mailto:serviceclient@adnov.fr">serviceclient&#64;adnov.fr</a>
        </p>
      </div>
    </div>
  </div>
</p-wrapper>
